import React, { useState, useEffect, FormEvent } from 'react';
import DeviceSelectionScreen from './DeviceSelectionScreen/DeviceSelectionScreen';
import IntroContainer from '../IntroContainer/IntroContainer';
import MediaErrorSnackbar from './MediaErrorSnackbar/MediaErrorSnackbar';
import RoomNameScreen from './RoomNameScreen/RoomNameScreen';
import { useAppState } from '../../state';
import { useParams } from 'react-router-dom';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { isAtendente, isSegurado } from '../../utils';

import IntroductionScreen from './IntroductionScreen/IntroductionScreen';
import TermsScreen from './TermsScreen/TermsScreen';
import GeolocationScreen from './GeolocationScreen/GeolocationScreen';
import PermissionInfoScreen from './PermissionInfoScreen/PermissionInfoScreen';

export enum Steps {
  roomNameStep,
  introductionStep,
  termsStep,
  geolocationStep,
  permissionInfoStep,
  deviceSelectionStep,
}

export default function PreJoinScreens() {
  const { user } = useAppState();
  const { getAudioAndVideoTracks } = useVideoContext();
  const { URLModulo, URLRoomName } = useParams<{ URLModulo?: string; URLRoomName: string }>();
  const [step, setStep] = useState(Steps.roomNameStep);

  const [name, setName] = useState<string>(user?.displayName || '');
  const [roomName, setRoomName] = useState<string>('');

  const [mediaError, setMediaError] = useState<Error>();

  useEffect(() => {
    if (URLRoomName) {
      setRoomName(URLRoomName);
      if (user?.displayName) {
        setStep(Steps.deviceSelectionStep);
      }
    }
  }, [user, URLRoomName]);

  useEffect(() => {
    if (step === Steps.deviceSelectionStep && !mediaError) {
      getAudioAndVideoTracks().catch(error => {
        console.log('Error acquiring local media:');
        console.dir(error);
        setMediaError(error);
      });
    }
  }, [getAudioAndVideoTracks, step, mediaError]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // If this app is deployed as a twilio function, don't change the URL because routing isn't supported.
    // @ts-ignore
    if (!window.location.origin.includes('twil.io') && !window.STORYBOOK_ENV) {
      if (URLModulo !== 'telereg' && URLModulo !== 'teleinsp') {
        throw new Error('Caminho inválido: a URL deve conter um módulo válido.');
      }

      window.history.replaceState(
        null,
        '',
        window.encodeURI(`/${URLModulo}/room/${roomName}${window.location.search || ''}`)
      );
    }

    if (isAtendente) {
      setStep(Steps.deviceSelectionStep);
    } else if (isSegurado) {
      setStep(Steps.termsStep);
    }
  };

  return (
    <IntroContainer>
      <MediaErrorSnackbar error={mediaError} />
      {step === Steps.roomNameStep && (
        <RoomNameScreen
          name={name}
          roomName={roomName}
          setName={setName}
          setRoomName={setRoomName}
          handleSubmit={handleSubmit}
        />
      )}

      {/* {step === Steps.introductionStep && (
        <IntroductionScreen
          name={name}
          onContinue={() => setStep(Steps.termsStep)}
          onBack={() => setStep(Steps.roomNameStep)}
        />
      )} */}

      {/* Tela aceite de termos  */}
      {isSegurado && step === Steps.termsStep && (
        <TermsScreen
          name={name}
          onContinue={() => setStep(Steps.deviceSelectionStep)}
          onBack={() => setStep(Steps.roomNameStep)}
        />
      )}

      {/* Tela localizacao  */}
      {/* {isSegurado && step === Steps.geolocationStep && (
        <GeolocationScreen
          onContinue={() => setStep(Steps.deviceSelectionStep)}
          onBack={() => setStep(Steps.termsStep)}
        />
      )} */}

      {/* Tela permissao microfone e camera  */}
      {/* {isSegurado && step === Steps.permissionInfoStep && (
        <PermissionInfoScreen
          onContinue={() => setStep(Steps.deviceSelectionStep)}
          onBack={() => setStep(Steps.geolocationStep)}
        />
      )} */}

      {/* Tela seleção de dispositivos (preview de camera e microfone)  */}
      {step === Steps.deviceSelectionStep && (
        <DeviceSelectionScreen
          name={name}
          roomName={roomName}
          onBack={() => setStep(isSegurado ? Steps.termsStep : Steps.roomNameStep)}
        />
      )}
    </IntroContainer>
  );
}
